module.exports = __webpack_public_path__ + "img/lg_ring_g_i_null_0@2x.0519dcaa.png";